/* eslint no-param-reassign: 'off' */

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export function makeStore ({ api }) {
    return new Vuex.Store({
        actions: {
            async ensureApplication ({ rootState, dispatch }) {
                await api.ensureApplication(rootState.solution.id, rootState.user.user.id);
                await dispatch('casting/updateApplication', {
                    casting: rootState.solution.id,
                    force: true,
                });
            },
            async updateProgress ({ rootState, commit }, progress) {
                // Application progress will automatically be updated in cache
                // but is read for Vuex so we need to update it too
                await api.updateProgress(rootState.casting.application.id, progress);
                commit('casting/SET_APPLICATION', {
                    ...rootState.casting.application,
                    progress,
                });
            },
            async linkProject ({ rootState }, project) {
                await api.linkProject(rootState.casting.application.id, project);
            },
        },
    });
}
